import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-farming',
  templateUrl: './farming.component.html',
  styleUrls: ['./farming.component.css']
})
export class FarmingComponent implements OnInit {
  disabledbutton : boolean = false;  
  pagitionfirst : boolean = false;
  pagitionsecond : boolean = false;
  paginationthird : boolean = false
  constructor() { }

  ngOnInit() {
    this.GetWhatsappNos();
    this.getPaginationfirst();
  }
  WhatsappList:any[]=[];
  GetWhatsappNos()
  {
    let nos =  (<HTMLInputElement>document.getElementById("hdnWhatsapp")).value;
    this.WhatsappList = nos.split(",");
  }

  getPaginationfirst(){
    this.pagitionsecond = false;
    this.pagitionfirst = true;
    document.getElementById("Page1").classList.add('active'); 
    document.getElementById("Page2").classList.remove('active');   
  }
  getPaginationsecond(){ 
    this.pagitionfirst = false;
    this.paginationthird = false;
    this.pagitionsecond = true;    
    document.getElementById("Page1").classList.remove('active');
    document.getElementById("Page2").classList.add('active');    
  }
 
  getPaginationnext(){
    if(this.pagitionfirst == true){
      this.getPaginationsecond();
    }
    
    else{
      this.disabledbutton= true;
    }
  }
  getPaginationPrevious(){
    if(this.pagitionsecond == true){
      this.getPaginationfirst();
    }
    else{
      this.disabledbutton= true;
    }
  }

}
